import { useCallback, useEffect, useState } from 'react';
import { clearPairing, loadConfig, readPreviewToken, saveApiUrl, saveKioskKey } from './lib/config';
import { installKioskHardening } from './lib/hardening';
import { KioskDisplay } from './KioskDisplay';
import { SetupScreen } from './screens/SetupScreen';

export function App() {
  const [config, setConfig] = useState(loadConfig);
  const [previewToken] = useState(readPreviewToken);

  // A preview runs in the owner's normal browser: leave context menu, zoom, cursor alone.
  useEffect(() => (previewToken ? undefined : installKioskHardening()), [previewToken]);

  const handleSave = useCallback((key: string, apiUrl: string | null) => {
    saveKioskKey(key);
    saveApiUrl(apiUrl);
    setConfig(loadConfig());
  }, []);

  const handleReset = useCallback(() => {
    clearPairing();
    setConfig(loadConfig());
  }, []);

  if (previewToken) {
    return <KioskDisplay apiUrl={config.apiUrl} credentials={{ previewToken }} onResetPairing={handleReset} />;
  }

  if (!config.kioskKey) {
    return <SetupScreen initialApiUrl={config.apiUrl} onSave={handleSave} />;
  }

  return (
    <KioskDisplay
      key={`${config.apiUrl}|${config.kioskKey}`}
      apiUrl={config.apiUrl}
      credentials={{ kioskKey: config.kioskKey }}
      onResetPairing={handleReset}
    />
  );
}
